import { render, staticRenderFns } from "./PuzzleItem.vue?vue&type=template&id=2abf7eb1&scoped=true&"
import script from "./PuzzleItem.vue?vue&type=script&lang=js&"
export * from "./PuzzleItem.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleItem.vue?vue&type=style&index=0&id=2abf7eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf7eb1",
  null
  
)

export default component.exports